var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 10,
    viewBox: "0 0 9 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.22583 4.42235L1.54251 0.103929C1.44286 0.0395516 1.32837 0.00391739 1.21091 0.000723619C1.09345 -0.00247015 0.977309 0.026893 0.874529 0.0857662C0.771748 0.144639 0.686076 0.230878 0.626401 0.335533C0.566727 0.440189 0.535224 0.559449 0.535162 0.68094V9.31829C0.534657 9.44002 0.565798 9.55965 0.625327 9.66467C0.684856 9.7697 0.770585 9.85625 0.873547 9.91528C0.976509 9.97431 1.09292 10.0036 1.2106 10.0002C1.32829 9.99679 1.44292 9.96073 1.54251 9.89581L8.22583 5.57739C8.3205 5.51612 8.39855 5.43098 8.45266 5.32996C8.50677 5.22893 8.53516 5.11535 8.53516 4.99987C8.53516 4.88439 8.50677 4.77081 8.45266 4.66978C8.39855 4.56876 8.3205 4.48362 8.22583 4.42235Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartIcon);
export default __webpack_public_path__ + "static/media/start-icon.8cb74e12dc1d968652b61b64818940cc.svg";
export { ForwardRef as ReactComponent };